import { FormItem, MenuPresets } from '@framework/form';
import { yup } from '@framework/validation';
import * as React from 'react';
import { RichTextAdvancedInput } from '../../../../../inputs/rich-text-advanced/RichTextAdvancedInput';
import { RichTextAdvancedSchema } from '../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { WidgetType } from '../../../Widget';
import { BaseLayoutColSpanInput } from '../../common/BaseLayoutColSpanInput';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { CommonContainerWidgetConfigSchema } from '../common/CommonContainerWidgetConfigSchema';
import { IQuestionWidget } from './IQuestionWidget';

export const QuestionWidgetConfigSchema =
  CommonContainerWidgetConfigSchema.shape({
    title: RichTextAdvancedSchema.optional().label('Titolo'),
    description: RichTextAdvancedSchema.optional().label('Descrizione'),
    type: yup.string().exact(WidgetType.Question).required(),
  }) satisfies yup.ObjectSchema<IQuestionWidget>;

export interface IQuestionWidgetConfigComponentProps
  extends IWidgetComponentProps<IQuestionWidget> {}

export function QuestionWidgetConfigComponent(
  props: IQuestionWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);
  return (
    <div>
      <BaseLayoutColSpanInput isTableColumn={options.isTableColumn} />

      <FormItem name="title" label="Titolo">
        <RichTextAdvancedInput
          name="title"
          menus={MenuPresets.Inline}
          rows={3}
        />
      </FormItem>

      <FormItem name="description" label="Descrizione">
        <RichTextAdvancedInput
          name="description"
          menus={MenuPresets.Block}
          rows={10}
        />
      </FormItem>
    </div>
  );
}
